<template>
  <section :class="{active: fighter.name}" class="fighter-profile" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">

    <div class="container full-width-small">
       <Scrollama class="fighter-profile-scroll" >

        <div class="graphic" :class="'fighter-graphic--' + fighter.fighter_class" slot="graphic" >
          <div class="fighter-image">
            <picture>
              <source :srcset="fighter.fighter_body_shot_image.mobile_image" media="(max-width: 540px)">
              <source :srcset="fighter.fighter_body_shot_image.tablet_image" media="(max-width: 768px)">
              <img :src="fighter.fighter_body_shot_image.desktop_image" :alt="fighter.name + ' fighter preview image'">
            </picture>
          </div>

        </div>



        <div  class="step fighter-profile-content"  data-step-no="1">

          <template v-if="fighter.name">
            <div class="fighter-overview">
              <h3 class="roboto-condensed">{{$t('fighters_overview')}}</h3>
              <FighterClass class="profile" :fighterClass="fighter.character_overview.fighter_class" />
              <!-- <FighterDifficulty class="profile" :difficulty="fighter.character_overview.fighter_difficulty" /> -->

            </div>


            <div class="fighter-background">
              <h3 class="roboto-condensed">{{$t('background')}}</h3>
              <p><strong>{{$t('age')}}:</strong> {{fighter.character_background.fighter_age}}</p>
              <p><strong>{{$t('birthplace')}}:</strong> {{fighter.character_background.fighter_birthplace}}</p>
              <p><strong>{{$t('birthdate')}}:</strong> {{fighter.character_background.fighter_birthdate}}</p>
            </div>

            <h3 class="roboto-condensed">{{$t('bio')}}</h3>

            <div class="roboto-condensed fighter-description" v-html="fighterDescription"></div>

          </template>

        </div>


      </Scrollama>


    </div>




  </section>
</template>

<script>
import 'intersection-observer' // for cross-browser support
import Scrollama from 'vue-scrollama'
//import FighterDifficulty from '@/components/ui/fighters/FighterDifficulty';
import FighterClass from '@/components/ui/fighters/FighterClass';


export default {
  name: 'FighterProfile',
  props: ['fighter'],
  data() {
    return {
      backgroundImages: {
        xs: 'mobile_image',
        s: 'mobile_image',
        m: 'mobile_image',
        l: 'mobile_image',
        xl: 'desktop_image'
      },
      currStep: null
    }
  },
  components: {
    Scrollama,
    //FighterDifficulty,
    FighterClass
  },
  computed: {
    imgUrl() {
      return 'https://via.placeholder.com/';
    },
    backgroundImage() {
      if(this.fighter.fighter_background_image) {
        let node = this.backgroundImages[this.$mq];
        return this.fighter.fighter_background_image[node];
      }
    },

    fighterDescription() {
      if(this.fighter) {
        if(this.fighter.content == '') {
          return this.fighter_short_description;
        } else {
          return this.fighter.content;
        }
      }
    }
  },
  methods: {

  }

};
</script>

<style lang="scss">

  .fighter-profile {
    background-color: #000;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100%;

    opacity: 0;
    transition: 0.2s opacity ease-in-out;
    position: relative;

    &:after {
      width: 100%;
      height: 100%;
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0,0,0,0.75);
      z-index: 1;
      pointer-events: none;
    }


    @include bp($bp--l) {
      background-size: cover;
    }

    &.active {
      opacity: 1;
    }

    .container {
      position: relative;
      z-index: 2;
    }
  }

  .fighter-image {
    display: block;

    img, picture {
      width: 100%;
      display: block;
      .fighter-graphic--fedik & {
        @include bp($bp--m) {
          width: 100%;
        }
        @include bp($bp--l) {
          width: 125%;
        }
        @include bp($bp--xl) {
          width: 100%;
        }
        @include bp($max-width) {
          width: 108%;
        }
        
      }
      .fighter-graphic--onerv & {
        width: 100%;
      }

      .fighter-graphic--jughe & {
        @include bp($bp--m) {
          width: 90%;
        }
        @include bp($bp--xl) {
          width: 85%;
        }
      }
      .fighter-graphic--lasho & {
        @include bp($bp--m) {
          width: 100%;
        }
      }
    }

    @include bp($bp--m) {
      width:100%;
      margin-left: 5%;
    }

    @include bp($bp--l) {
      width:60%;
      padding-top: 0%;

      .fighter-graphic--lasho & {
        width: 75%;
      }
      .fighter-graphic--maten & {
        width: 58%;
      }
    }

    @include bp($bp--xl) {
      width:75%;
      padding-top: 0%;

      .fighter-graphic--lasho & {
        width: 70%;
      }

    }

    .fighter-graphic--onerv &,
    .fighter-graphic--ownro & {
      width: 100%;
    }
  }


  .graphic {
    padding: 30px 0;
    //background-color: orange;
    @include bp($bp--m) {
      display: flex;
      justify-content: flex-start;
      padding: 0;
    }

    @include bp($bp--xl) {
      justify-content: center;
    }
  }

  // hide on mobile
  .resize-observer {
    display: none;
  }

  @include bp($bp--m) {
    .scrollama-container {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      .scrollama-graphic {
       flex: 1;
       height: 100%;
       top: 130px;
       @include bp($bp--l) {
        top: 100px;
       }
       @include bp($bp--xl) {
        top: 150px;
       }
        // height: 80vh;
        // top: 10vh;

      }
      .scrollama-steps {
        flex: 1;
        max-width: 560px;
      }
    }

    .scrollama-container {
      position: relative;
    }
    .scrollama-graphic {
      position: sticky;
      top: 0;
    }
    .scrollama-steps {
      position: relative;
    }
    .resize-observer[data-v-b329ee4c]{
      position:absolute;
      top:0;
      left:0;
      z-index:-1;
      width:100%;
      height:100%;
      border:none;
      background-color:transparent;
      pointer-events:none;
      display:block;
      overflow:hidden;
      opacity:0
    }
    .resize-observer[data-v-b329ee4c] object{
      display:block;
      position:absolute;
      top:0;
      left:0;
      height:100%;
      width:100%;
      overflow:hidden;
      pointer-events:none;
      z-index:-1
    }
  }

  .fighter-profile-content {
    color: #fff;
    padding: 60px 30px;

    border-image: url('~@/assets/images/border-mask-fighter.png');
    border-image-repeat: stretch repeat;
    border-image-slice: 100 120 95 fill;
    border-image-width: 10% 10%;

    @include bp($bp--m) {
      padding: 60px 24px;
    }

    @include bp($bp--l) {
      padding: 70px 50px;

    }

    strong {
      font-weight: bold;
    }

    h3 {
      font-weight: bold;
      text-transform: uppercase;
      font-size: 17px;
      margin-bottom: 30px;
      margin-top: 40px;

      @include bp($bp--m) {
        font-size: 30px;
      }

      .fighter-overview & {
        margin-bottom: 30px;
        @include bp($bp--m) {
          margin-bottom: 70px;
        }
      }
    }

    .fighter-description p {
      margin-bottom: 20px;
      font-size: 15px;
      line-height: 21px;
      @include bp($bp--m) {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .fighter-overview {
    > h3 {
      margin-top: 0;
    }
  }

  // Fighter Background
  .fighter-background {
    p {
      margin-bottom: 5px;
      line-height: 24px;
      @include bp($bp--m) {
        margin-bottom: 10px;
      }
    }

    margin-bottom: 28px;

    @include bp($bp--m) {
      margin-bottom: 55px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/ui/fighters/FighterProfile.vue